import { render, staticRenderFns } from "./CouponListItem.vue?vue&type=template&id=bfca3362&"
import script from "./CouponListItem.vue?vue&type=script&lang=ts&"
export * from "./CouponListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports